<template>
  <div :class="dsSelectClass">
    <select
      :id="id"
      type="text"
      :name="name"
      placeholder=""
      v-model="valueModel"
      :clicked="true"
      :required="required"
      @blur="visited = true"
      ref="dsSelect"
      ds-component="DsSelect"
    >
      <option
        v-for="(option, index) in getOptions"
        :key="index"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <DsIcon v-if="icon" size="small" :name="icon" />
    <div class="ds-select__arrow" />
    <span class="ds-select__top-border">
        <label>{{ required ? `${label} *` : label }}</label>
    </span>
    <div class="ds-select__helpers">
      <span
        v-if="helpText"
        class="ds-select__helpers-text"
      >
        <small>{{ helpText }}</small>
      </span>
      <span
        class="ds-select__helpers-error"
      >
        <small>{{ errorText }}</small>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck
import Vue from 'vue';
import Tokens from '@ds/tokens';
import { DsIcon } from '@ds/icons';

export default Vue.extend({
  name: 'DsSelect',
  components: {
    DsIcon
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: false,
      default() {
        return [];
      },
      validator(options) {
        const isStringOrObjectArray = options.every((option) => {
          return typeof option === 'string' ||
            Object.getPrototypeOf(option) === Object.prototype;
        });

        const isValid = isStringOrObjectArray || !options.length;

        if (!isValid)
          throw new Error('"options" prop must to be an array containing strings or objects.');
        return isValid;
      }
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    helpText: {
      type: String,
      required: false
    },
    errorText: {
      type: String,
      required: false,
      default: ''
    },
    inputClass: {
      type: String,
      required: false,
      default: 'default'
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      visited: false,
    };
  },
  computed: {
    dsSelectClass() {
      return {
        'ds-select': true,
        'ds-select--visited': this.visited,
        'ds-select--disabled': this.disabled,
        'ds-select--icon': Boolean(this.icon),
        'ds-select--empty': !Boolean(this.value),
        [`ds-select--${this.inputClass}`]: true,
      };
    },
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
    getOptions() {
      return this.options.map(option => {
        const isObjectValue = Object.getPrototypeOf(option) === Object.prototype;

        if (isObjectValue) return option;

        return {
          value: option,
          label: option
        }
      });
    }
  },
  mounted() {
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/Select.scss';
</style>
